import React, { useState , useEffect} from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Switch,
  FormControlLabel,
  Box,
  IconButton,
  Stack,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const PublicLinkPopup = ({ open, onClose, position ,setIsPublicEnabled,isPublicEnabled, publicLink, positionId}) => {
  const [copySuccess, setCopySuccess] = useState(false); 

  const handleTogglePublic = () => {
    setIsPublicEnabled((prev) => !prev);
  };
  useEffect(() => {
    if (position?.public_link_enabled !== undefined) {
      setIsPublicEnabled(position.public_link_enabled === "1"); 
    }
  }, [position?.public_link_enabled, setIsPublicEnabled]);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => setCopySuccess(true)) 
      .catch((err) => console.error("Failed to copy: ", err));
  };
  const baseURL = "https://uiwebsite.schoolmgmtsys.com" || window.location.origin;
  const fullPublicLink = publicLink 
    ? `${baseURL}/#/public-interview?publicLink=${publicLink}`
    : "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "12px" } }}>
      <Stack p={2} spacing={2} position="relative">
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 30,
            color: "grey.600",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            Public Link
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Create a unique link for this position where any amount of candidates can apply
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F3F4F6",
              padding: "8px 12px",
              borderRadius: "6px",
              mt: 2,
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2" color="primary" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {fullPublicLink}
            </Typography>
            <IconButton onClick={() => handleCopy(fullPublicLink)} size="small">
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Box>

          <Stack spacing={1} mt={2}>
            <FormControlLabel
              control={<Switch checked={isPublicEnabled} onChange={handleTogglePublic} />}
              label="Enable applications through public link"
            />
            <FormControlLabel control={<Switch disabled={!isPublicEnabled} />} label="Force candidates to verify their email before answering" />
            <FormControlLabel control={<Switch />} label="Show phone number field" />
            <FormControlLabel control={<Switch disabled={!isPublicEnabled} />} label="Make phone number mandatory" />
          </Stack>
        </DialogContent>
      </Stack>

      <Snackbar
        open={copySuccess}
        autoHideDuration={3000} 
        onClose={() => setCopySuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setCopySuccess(false)} severity="success" sx={{ width: "100%" }}>
          Link copied successfully!
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default PublicLinkPopup;
